export default __webpack_public_path__ + "static/media/icono-twitter.36d1757f.svg";